import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Input,
  Collapse,
  Form,
  Label,
} from "reactstrap";
import CustomButton from "../CustomButton";
import CartTitle from "../CartTitle";
import MaterialTable from "material-table";
import "../../assets/scss/components/MeterialTable/index.scss";
import get from "lodash/get";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InputText from "../InputText";

import DesignCard from "../DesignCard";

const _ = { get };

export default class ReviewModerationMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleActive: true,
      toggleCollapse: false,
      country: "",
      countryCode: "",
      count: 100,
      stateCode: "",
      state: "",
      page: 0,
      city: "",
      name: "",
      status: "PENDING",
      category: "ride",
      branchId: "",
      branchName: "",
      activityId: "",
      activityName: "",
      finalCategory: "ride",
      exportEmail: "",
    };
  }

  componentDidMount() {
    let state = this.state;
    let data = {
      countryCode: state.countryCode,
      category: state.category,
      status: state.status,
      activityId: state.activityId,
      branchId: state.branchId,
    };
    this.props.handleFetchReviewForModeration(data);
    this.handleFetchCountryFromCategory("PENDING", "ride");
  }

  handleFetchCountryFromCategory = (status, category) => {
    const data = {
      status: status,
      category: category,
    };
    this.props.handleFetchReviewCountry(data);
  };

  handleToggle = (e) => {
    let state = this.state;
    state.toggleActive = !state.toggleActive;
    this.setState({ ...state });
  };

  handleFilterChange = (e, id) => {
    let state = this.state;
    if (id === "email") {
      state[e.target.name] = e.target.value;
      this.setState({ ...state });
    }
  };

  handleChangeStatus = (e) => {
    let state = this.state;
    state.status = e.target.value;
    this.setState({ ...state });
  };

  handleChangeCategory = (e) => {
    this.setState({
      category: e.target.value,
      country: "",
      branchName: "",
      branchId: "",
      countryCode: "",
      activityId: "",
    });
    this.handleFetchCountryFromCategory(this.state.status, e.target.value);
    const data = {
      countryCode: "",
      category: "",
      status: "",
    };

    this.props.handleFetchBranch(data);
  };

  handleCountryChange = (e) => {
    let state = this.state;
    if (e.target.value !== "Select Country") {
      state.countryCode = e.target.value;
      state.branchId = "";
      state.activityId = "";
    }
    const data = {
      countryCode: e.target.value,
      category: state.category,
      status: state.status,
    };
    this.setState({ ...state });
    this.props.handleFetchBranch(data);
  };

  handleBranchChange = (e) => {
    let state = this.state;
    if (e.target.value !== "Select Branch") {
      state.branchId = e.target.value;
      this.setState({ ...state });
      let data = {
        category: state.category,
        countryCode: state.countryCode,
        branchId: e.target.value,
      };
      this.props.handleFetchActivityForReview(data);
    }
  };

  handleActivityChange = (e) => {
    let state = this.state;
    if (e.target.value !== "Select Activity") {
      state.activityId = e.target.value;
      this.setState({ ...state });
    }
  };

  handleToggleIcon = (e) => {
    let state = this.state;
    state.toggleCollapse = !state.toggleCollapse;
    if (state.toggleActive === true) {
      state.toggleActive = !state.toggleActive;
      this.setState({ ...state });
    }

    this.setState({ ...state });
  };

  handleExportData = (e) => {
    let state = this.state;
    let { elements } = this.props;
    let data = {
      email: state.exportEmail,
      // activityName: state.activityName,
      category: state.category,
      status: state.status,
    };
    if (state.exportEmail === "")
      return toast.error(
        _.get(
          elements,
          "userMembershipListingFilterElements.emailValidationElement",
          "Email cannot be empty"
        )
      );
    return this.props.handleExportToExcel(data);
  };

  handleSubmitFilter = (e) => {
    e.preventDefault();
    let state = this.state;
    let data = {
      countryCode: state.countryCode,
      branchId: state.branchId,
      status: state.status,
      category: state.category,
      activityId: state.activityId,
    };
    state.finalCategory = state.category;
    this.setState({ ...state });

    this.props.handleFetchReviewFilter(data);
  };

  handleClearFilter = () => {
    let state = this.state;
    state.countryCode = "";
    state.country = "";
    state.branchName = "";
    state.branchId = "";
    state.category = "ride";
    state.activityId = "";
    this.setState({ ...state });
    let data = {
      countryCode: "",
      category: "ride",
      status: "PENDING",
      branchId: "",
    };
    this.props.handleFetchReviewForModeration(data);
  };

  render() {
    let { elements } = this.props;
    return (
      <div className="hideSearch">
        <Form onSubmit={this.handleSubmitFilter}>
          <Row>
            <Col sm={12}>
              <CartTitle
                title={_.get(
                  elements,
                  "reviewListTableElement.headingElement",
                  "Review"
                )}
                Name={_.get(
                  elements,
                  "reviewListTableElement.filterButtonElement",
                  "Filter"
                )}
                handleToggle={() => this.handleToggle()}
                iconClass={"hideexcel"}
                customExcelClick={() => this.handleToggleIcon()}
                preRegisteredUserCount={this.props.dealerCount}
              />
            </Col>
            <Col sm={12}>
              <Collapse isOpen={this.state.toggleActive}>
                <Card className="mb-3">
                  <CardBody>
                    <Row>
                      <Col xl={4} lg={4} md={6} sm={6}>
                        <Label className="inputLabel">
                          {_.get(
                            elements,
                            "reviewListTableElement.categoryLabelElement",
                            "Category"
                          )}
                        </Label>
                        <FormGroup className=" confirmRiderSelect select_options">
                          <Input
                            type="select"
                            name="Category"
                            className="w-100 customeSelectBtn"
                            onChange={(e) => this.handleChangeCategory(e)}
                            value={this.state.category}
                          >
                            <option value={"ride"}>
                              {_.get(
                                elements,
                                "reviewListTableElement.selectRideElement",
                                "Ride"
                              )}
                            </option>
                            <option value={"event"}>
                              {_.get(
                                elements,
                                "reviewListTableElement.selectEventElement",
                                "Event"
                              )}
                            </option>
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col xl={4} lg={4} md={6} sm={6}>
                        <Label className="inputLabel">
                          {_.get(
                            elements,
                            "reviewListTableElement.countryLabelElement",
                            "Country"
                          )}
                        </Label>
                        <FormGroup className=" confirmRiderSelect select_options">
                          <Input
                            type="select"
                            name="country"
                            className="w-100 customeSelectBtn"
                            onChange={this.handleCountryChange}
                            value={this.state.countryCode}
                          >
                            <option>
                              {_.get(
                                elements,
                                "reviewListTableElement.selectCountryElement",
                                "Select Country"
                              )}
                            </option>
                            {this.props.reviewCountries.map((item, index) => (
                              <option value={item._id.countryCode}>
                                {item._id.country}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col xl={4} lg={4} md={6} sm={6}>
                        <Label className="inputLabel">
                          {_.get(
                            elements,
                            "reviewListTableElement.branchLabelElement",
                            "Branch"
                          )}
                        </Label>
                        <FormGroup className=" confirmRiderSelect select_options">
                          <Input
                            type="select"
                            name="Branch"
                            className="w-100 customeSelectBtn"
                            onChange={this.handleBranchChange}
                            value={this.state.branchId}
                          >
                            <option>
                              {_.get(
                                elements,
                                "reviewListTableElement.selectBranchLabelElement",
                                "Select Branch"
                              )}
                            </option>
                            {this.props.branchesForReviews.map(
                              (item, index) => (
                                <option key={index} value={item.branchId}>
                                  {item.branchName}
                                </option>
                              )
                            )}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={4} lg={4} md={6} sm={6}>
                        <Label className="inputLabel">
                          {_.get(
                            elements,
                            "reviewListTableElement.activityLabelElement",
                            "Activity"
                          )}
                        </Label>
                        <FormGroup className=" confirmRiderSelect select_options">
                          <Input
                            type="select"
                            name="Branch"
                            className="w-100 customeSelectBtn"
                            onChange={this.handleActivityChange}
                            value={this.state.activityId}
                          >
                            <option>
                              {_.get(
                                elements,
                                "reviewListTableElement.selectActivityLabelElement",
                                "Select Activity"
                              )}
                            </option>
                            {this.props.activityForReview.map((item, index) => (
                              <option key={index} value={item._id}>
                                {this.state.category === "ride"
                                  ? item.rideName
                                  : item.eventName}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                      <CustomButton
                        customType={"submit"}
                        name={_.get(
                          elements,
                          "reviewListTableElement.searchButtonElement",
                          "Search"
                        )}
                        customClass={"btn-outline-dark bg-none btnthemeColor"}
                      />
                      <CustomButton
                        customType={"button"}
                        name={_.get(
                          elements,
                          "reviewListTableElement.clearFilterButtonElement",
                          "Clear Filter"
                        )}
                        customClass={
                          "btn-outline-dark bg-none ml-2 btnthemeColor"
                        }
                        customClick={this.handleClearFilter}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Collapse>
              <Collapse isOpen={this.state.toggleCollapse}>
                <Card className="mb-3">
                  <CardBody>
                    <Row className="justify-content-start">
                      <Col lg={4}>
                        <InputText
                          labelName={_.get(
                            elements,
                            "userMembershipListingFilterElements.exportToExcelEmailLabel",
                            "Email"
                          )}
                          inputType={"email"}
                          inputName={"exportEmail"}
                          InputClass={"inputText mb-0"}
                          inputPlaceholder={_.get(
                            elements,
                            "userMembershipListingFilterElements.exportToExcelEmailPlaceholder",
                            "Email"
                          )}
                          customValue={this.state.exportEmail}
                          customOnChange={(e) =>
                            this.handleFilterChange(e, "email")
                          }
                        />
                      </Col>

                      <Col
                        lg={2}
                        className="d-flex align-items-center justify-content-start"
                      >
                        <div className="mt-2 pt-1">
                          <CustomButton
                            customType={"button"}
                            name={_.get(
                              elements,
                              "userMembershipListingFilterElements.exportToExcelButton",
                              "Export To Excel"
                            )}
                            customClass={
                              "btn-outline-dark bg-none btnthemeColor"
                            }
                            customClick={() => this.handleExportData()}
                          />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Collapse>
            </Col>
          </Row>
        </Form>

        <Row>
          <Col sm="12">
            <div className="custom-m-table">
              <MaterialTable
                title=""
                columns={[
                  {
                    title: _.get(
                      elements,
                      "reviewListTableElement.activityTypeElement",
                      "Activity Type"
                    ),
                    field: "activity.category",
                  },
                  {
                    title: _.get(
                      elements,
                      "reviewListTableElement.activityNameElement",
                      "Activity name"
                    ),
                    render: (rowData) => {
                      return this.state.finalCategory === "ride"
                        ? rowData.activity.categoryId &&
                            rowData.activity.categoryId.rideName
                        : rowData.activity.categoryId &&
                            rowData.activity.categoryId.eventName;
                    },
                  },

                  {
                    title: _.get(
                      elements,
                      "reviewListTableElement.experieceElement",
                      "Experience"
                    ),
                    field: "experience",
                  },
                  {
                    title: _.get(
                      elements,
                      "reviewListTableElement.interestElement",
                      "Interest"
                    ),

                    field: "interest",
                  },
                  {
                    title: _.get(
                      elements,
                      "reviewListTableElement.organisationElement",
                      "Organisation"
                    ),
                    field: "organisation",
                  },
                  {
                    title: _.get(
                      elements,
                      "reviewListTableElement.overallElement",
                      "Overall"
                    ),
                    field: "overall",
                  },
                  {
                    title: _.get(
                      elements,
                      "reviewListTableElement.descriptionElement",
                      "Description"
                    ),
                    field: "description",
                    render: (rowData) => {
                      return (
                        <span className="textColumn">
                          {rowData.description ? rowData.description : "N/A"}
                        </span>
                      );
                    },
                  },
                ]}
                data={this.props.reviewForModeration}
                options={{
                  actionsColumnIndex: -1,
                  search: false,
                  paging: true,
                  sorting: false,
                  pageSize: 10,
                }}
                localization={{
                  body: {
                    emptyDataSourceMessage: (
                      <h6>
                        {_.get(
                          elements,
                          "rideListTableElement.noRecordsFoundElement",
                          "No records to display"
                        )}
                      </h6>
                    ),
                  },
                  pagination: {
                    labelRowsSelect: _.get(
                      elements,
                      "customMaterialTableElement.labelRowsSelect",
                      "rows"
                    ),
                    previousTooltip: _.get(
                      elements,
                      "customMaterialTableElement.previousTooltip",
                      "previous"
                    ),
                    nextTooltip: _.get(
                      elements,
                      "customMaterialTableElement.nextTooltip",
                      "next"
                    ),
                  },
                  header: {
                    actions: _.get(
                      elements,
                      "rideListTableElement.actionsElement",
                      "Actions"
                    ),
                  },
                }}
                detailPanel={(rowData) => {
                  return (
                    <React.Fragment>
                      {rowData ? (
                        <div className="hideSearch my-3 px-3">
                          <Row>
                            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "reviewListTableElement.activityTypeElement",
                                  "Activity Type"
                                )}
                                titleName={rowData.activity.category}
                              />
                            </Col>
                            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "reviewListTableElement.activityNameElement",
                                  "Activity Name"
                                )}
                                titleName={
                                  this.state.finalCategory === "ride"
                                    ? rowData.activity.categoryId &&
                                      rowData.activity.categoryId.rideName
                                    : rowData.activity.categoryId &&
                                      rowData.activity.categoryId.eventName
                                }
                              />
                            </Col>
                            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "reviewListTableElement.experienceElement",
                                  "Experience"
                                )}
                                titleName={rowData.experience}
                              />
                            </Col>
                            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "reviewListTableElement.interestElement",
                                  "Interest"
                                )}
                                titleName={rowData.interest}
                              />
                            </Col>

                            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "reviewListTableElement.organisationElement",
                                  "Organistion"
                                )}
                                titleName={rowData.organisation}
                              />
                            </Col>

                            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "reviewListTableElement.overallElement",
                                  "Overall"
                                )}
                                titleName={rowData.overall}
                              />
                            </Col>

                            <Col xl={6} lg={6} md={6} sm={6} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "reviewListTableElement.descriptionElement",
                                  "Description"
                                )}
                                titleName={
                                  rowData.description
                                    ? rowData.description
                                    : "N/A"
                                }
                              />
                            </Col>
                          </Row>
                        </div>
                      ) : null}
                    </React.Fragment>
                  );
                }}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
